// extracted by mini-css-extract-plugin
export default {"control":"Product_control__mG18g","richText":"Product_richText__moAQE"};